"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThisYear = getThisYear;
exports.getYear = getYear;
exports.isQuotaTypeAnAverage = isQuotaTypeAnAverage;
exports.getStartOfPeriod = getStartOfPeriod;
exports.getDefaultDates = getDefaultDates;
exports.getStartOfCurrentPeriod = getStartOfCurrentPeriod;
exports.getEndOfPeriod = getEndOfPeriod;
exports.getNextDates = getNextDates;
exports.getPrevDates = getPrevDates;
exports.getRemainingDatesInYear = getRemainingDatesInYear;
exports.getDatesForYear = getDatesForYear;
exports.getDatesForTwoYears = getDatesForTwoYears;
exports.getCurrentDatesForYear = getCurrentDatesForYear;
exports.getBasicGoalsDates = getBasicGoalsDates;
exports.getQuotaTotalsList = getQuotaTotalsList;
exports.getQuotaAveragesList = getQuotaAveragesList;
exports.sortRowsByOwnerAndPipeline = sortRowsByOwnerAndPipeline;
exports.typeHasPipelines = typeHasPipelines;
exports.cantAddUserToTable = cantAddUserToTable;
exports.getQuotaDisplayValue = getQuotaDisplayValue;
exports.getQuotaSaveValue = getQuotaSaveValue;

var _I18n = _interopRequireDefault(require("I18n"));

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var _immutable = require("immutable");

var timeConversions = _interopRequireWildcard(require("./timeConversions"));

var _Constants = require("../Constants");

function getThisYear() {
  return _I18n.default.moment().year();
}

function getYear(visibleDates) {
  return visibleDates.first().year();
}

function isQuotaTypeAnAverage(quotaType) {
  return (0, _immutable.Set)([_Constants.QUOTA_TYPES.AVERAGE_TICKET_RESOLUTION_TIME, _Constants.QUOTA_TYPES.AVERAGE_TICKET_RESPONSE_TIME]).has(quotaType);
}

function getStartOfPeriod(period, date) {
  return _I18n.default.moment(date).startOf(_Constants.PERIOD_UNIT_TO_MOMENT_SINGULAR[period]);
}

function getDefaultDates(period) {
  var start = getStartOfPeriod(period, _I18n.default.moment.utc());

  if (period === _Constants.QUOTA_PERIODS.MONTHLY) {
    start = start.startOf('year');
  }

  var periodUnit = _Constants.PERIOD_UNIT_TO_MOMENT[period];
  return (0, _immutable.Range)(0, _Constants.NUM_PER_PERIOD[period]).map(function (num) {
    return _I18n.default.moment(start).add(num, periodUnit);
  }).toList();
}

function getStartOfCurrentPeriod(period) {
  return getStartOfPeriod(period, _I18n.default.moment.utc());
}

function getEndOfPeriod(period, date) {
  return _I18n.default.moment(date).endOf(_Constants.PERIOD_UNIT_TO_MOMENT_SINGULAR[period]);
}

function getNextDates(period, dates) {
  var numToSkip = _Constants.PERIOD_UNITS_TO_SKIP[period];
  var periodUnit = _Constants.PERIOD_UNIT_TO_MOMENT[period];
  var newestDate = dates.last();
  return dates.splice(0, numToSkip).concat((0, _immutable.Range)(1, numToSkip + 1).map(function (num) {
    return _I18n.default.moment(newestDate).add(num, periodUnit);
  })).toList();
}

function getPrevDates(period, dates) {
  var numToSkip = _Constants.PERIOD_UNITS_TO_SKIP[period];
  var periodUnit = _Constants.PERIOD_UNIT_TO_MOMENT[period];
  var oldestDate = dates.first();
  return (0, _immutable.Range)(1, numToSkip + 1).map(function (num) {
    return _I18n.default.moment(oldestDate).subtract(num, periodUnit);
  }).reverse().concat(dates.splice(dates.size - numToSkip, dates.size)).toList();
}

function getRemainingDatesInYear(period, startDate) {
  var dates = (0, _immutable.List)();

  var curDate = _I18n.default.moment(startDate).add(1, _Constants.PERIOD_UNIT_TO_MOMENT[period]);

  while (curDate.year() === startDate.year()) {
    dates = dates.push(_I18n.default.moment(curDate));
    curDate.add(1, _Constants.PERIOD_UNIT_TO_MOMENT[period]);
  }

  return dates;
}

function getDatesForYear(year, period) {
  var start = _I18n.default.moment.utc().startOf('year').set('year', year);

  return (0, _immutable.List)().push(start).concat(getRemainingDatesInYear(period, start));
}

function getDatesForTwoYears(year, period) {
  return getDatesForYear(year, period).concat(getDatesForYear(year + 1, period));
}

function getCurrentDatesForYear(period) {
  var start = _I18n.default.moment.utc().startOf('year');

  return (0, _immutable.List)().push(start).concat(getRemainingDatesInYear(period, start));
}

function getBasicGoalsDates() {
  var start = _I18n.default.moment().utc().startOf('year');

  return (0, _immutable.Range)(1, _Constants.NUM_BASIC_GOAL_MONTHS).reduce(function (dates) {
    return dates.push(_I18n.default.moment(dates.last()).add(1, 'month'));
  }, (0, _immutable.List)([start]));
}

function reduceQuotaColumns(visibleDates, quotaRowsList, reducerFunction) {
  return visibleDates.map(function (curDate) {
    return reducerFunction(quotaRowsList.filter(function (quotaRow) {
      return quotaRow.quotasByStart.has(curDate.valueOf());
    }).map(function (quotaRow) {
      return quotaRow.quotasByStart.get(curDate.valueOf());
    }));
  });
}

function totalQuotas(quotasList) {
  return quotasList.reduce(function (total, quota) {
    return total + quota.value;
  }, 0);
}

function averageQuotas(quotasList) {
  return totalQuotas(quotasList) / quotasList.size;
}

function getQuotaTotalsList(visibleDates, quotaRowsList) {
  return reduceQuotaColumns(visibleDates, quotaRowsList, totalQuotas);
}

function getQuotaAveragesList(visibleDates, quotaRowsList) {
  return reduceQuotaColumns(visibleDates, quotaRowsList, averageQuotas);
}

function getRowSortValue(quotaRow, owners, pipelines) {
  var owner = owners.get(quotaRow.ownerId);
  var pipeline = '';

  if (quotaRow.pipelineId && pipelines.has(quotaRow.pipelineId)) {
    pipeline = pipelines.get(quotaRow.pipelineId).label;
  }

  return (0, _formatName.default)(owner.toJS()) + ":" + pipeline;
}

function sortRowsByOwnerAndPipeline(_ref) {
  var owners = _ref.owners,
      pipelines = _ref.pipelines,
      row1 = _ref.row1,
      row2 = _ref.row2;
  return getRowSortValue(row1, owners, pipelines) > getRowSortValue(row2, owners, pipelines);
}

function typeHasPipelines(type) {
  return (0, _immutable.Set)([_Constants.QUOTA_TYPES.REVENUE, _Constants.QUOTA_TYPES.DEALS_CREATED, _Constants.QUOTA_TYPES.TICKETS_CLOSED, _Constants.QUOTA_TYPES.AVERAGE_TICKET_RESOLUTION_TIME, _Constants.QUOTA_TYPES.AVERAGE_TICKET_RESPONSE_TIME]).includes(type);
}

function cantAddUserToTable(_ref2) {
  var quotasTable = _ref2.quotasTable,
      pipelines = _ref2.pipelines,
      owner = _ref2.owner;
  var quotaType = quotasTable.quotaType,
      ownerPipelineIds = quotasTable.ownerPipelineIds,
      ownerIds = quotasTable.ownerIds;

  if (typeHasPipelines(quotaType)) {
    var ownerPipelines = ownerPipelineIds.get(owner.ownerId);
    return ownerPipelines && ownerPipelines.size === pipelines.getByType(quotaType).size;
  }

  return ownerIds.has(owner.ownerId);
}

function getQuotaDisplayValue(_ref3) {
  var quotaType = _ref3.quotaType,
      value = _ref3.value;

  if (quotaType === _Constants.QUOTA_TYPES.AVERAGE_TICKET_RESPONSE_TIME) {
    return timeConversions.msToHours(value);
  }

  if (quotaType === _Constants.QUOTA_TYPES.AVERAGE_TICKET_RESOLUTION_TIME) {
    return timeConversions.msToDays(value);
  }

  return value;
}

function getQuotaSaveValue(_ref4) {
  var quotaType = _ref4.quotaType,
      displayValue = _ref4.displayValue;
  var value = parseInt(displayValue, 10);

  if (quotaType === _Constants.QUOTA_TYPES.AVERAGE_TICKET_RESPONSE_TIME) {
    return timeConversions.hoursToMs(value);
  }

  if (quotaType === _Constants.QUOTA_TYPES.AVERAGE_TICKET_RESOLUTION_TIME) {
    return timeConversions.daysToMs(value);
  }

  return value;
}